/**
 * Inline MSW response for the backfills admin view (/apollo/backfills). Spread into the ENV-wide
 * INLINE_RESPONSES map. Shows one of each status so the table renders all badge colours.
 */
export const BACKFILLS_INLINE_RESPONSES = {
  "/apollo/backfills": {
    backfills: [
      {
        name: "BackfillCarrierDocumentHashes",
        status: "succeeded",
        lastStartedAt: "2026-06-16T03:00:00Z",
        lastFinishedAt: "2026-06-16T03:06:24Z",
        lastError: undefined,
      },
      {
        name: "BackfillCompanyAnnualRevenue",
        status: "pending",
        lastStartedAt: undefined,
        lastFinishedAt: undefined,
        lastError: undefined,
      },
      {
        name: "BackfillShipmentLaneGeohash",
        status: "failed",
        lastStartedAt: "2026-06-15T03:00:00Z",
        lastFinishedAt: "2026-06-15T03:00:11Z",
        lastError: "Timed out reading shipment 9d2f… from S3",
      },
    ],
    recentRuns: [
      {
        taskName: "BackfillCarrierDocumentHashes",
        status: "succeeded",
        startedAt: "2026-06-16T03:00:00Z",
        finishedAt: "2026-06-16T03:06:24Z",
        errorMessage: undefined,
      },
      {
        taskName: "BackfillShipmentLaneGeohash",
        status: "failed",
        startedAt: "2026-06-15T03:00:00Z",
        finishedAt: "2026-06-15T03:00:11Z",
        errorMessage: "Timed out reading shipment 9d2f… from S3",
      },
    ],
  },
};
